<template>
  <div class="text-center" style="padding: 24vh 0 10vh">
    <i class="fa fa-frown-o fa-3x"></i>
    <h5 class="mt-3">Página não encontrada!</h5>
    <p class="mb-4">O endereço digitado não existe em nosso App.</p>
    <a href="/" class="btn btn-outline-primary">Voltar para Home</a>
  </div>
</template>

<script>
  import Loading from '../components/Loading'

  export default {
    name: 'NotFound',
    components: {Loading},
    data() {
      return {
        load: true
      }
    }
  }
</script>
